import { lazy } from 'react';

// pages container.
const Pages = {
    Main: lazy(() => import('pages/main')),
};

const TraumatologyPages = {
    General: lazy(() => import('pages/traumatology/general')),
    FormCase: lazy(() => import('pages/traumatology/cases')),
    DetailCase: lazy(() => import('pages/traumatology/detail')),
};

const MentalHealtPages = {
    Dashboard: lazy(() => import('pages/mental-health/dashboard')),
    FormCase: lazy(() => import('pages/mental-health/case')),
    DetailCase: lazy(() => import('pages/mental-health/detail')),
};

const AdminPages = {
    Users: lazy(() => import('pages/admin/users')),
    FormUsers: lazy(() => import('pages/admin/users/form')),
    Settings: lazy(() => import('pages/admin/settings')),
    Solicitude: lazy(() => import('pages/access_solicitude/form/AccessSolicitudeFormPage')),
};

const UserPages = {
    Profile: lazy(() => import('pages/profile/ProfilePage')),
    Notifications: lazy(() => import('pages/notification')),
}

/**
 * Objeto con la definición de las diferentes rutas de la plataforma que se pueden acceder luego de iniciar sesión 
 */
export default [
    {
        key: 'profile-page',
        title: 'Perfil de usuario',
        path: '/profile',
        Child: UserPages.Profile,
        payload: {
            header: {
                title: 'Perfil de usuario',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'notifications-page',
        title: 'Notificaciones de usuario',
        path: '/notifications',
        Child: UserPages.Notifications,
        payload: {
            header: {
                title: 'Notificaciones de usuario',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'main-page',
        title: 'Inicio',
        path: '/',
        Child: Pages.Main,
        payload: {
            header: {
                title: 'Mis Aplicaciones',
                showButtonGoBack: false,
            },
        },
    },
    {
        key: 'traumaology-general-page',
        title: 'Vista general de traumatología',
        path: '/traumatology/general',
        Child: TraumatologyPages.General,
        payload: {
            header: {
                title: 'Gestión de pacientes traumatología',
            },
        },
    },
    {
        key: 'traumatology-formcase-page',
        title: 'Gestión de pacientes traumatología - Crear caso',
        path: '/traumatology/formcase',
        Child: TraumatologyPages.FormCase,
        payload: {
            header: {
                title: 'Gestión de pacientes traumatología - Crear caso',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'traumatology-detail-page',
        title: 'Gestión de pacientes traumatología - Detalle del paciente',
        path: '/traumatology/case/:id?',
        Child: TraumatologyPages.DetailCase,
        payload: {
            header: {
                title: 'Gestión de pacientes traumatología - Detalle del paciente',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'health-mental-dashboard-page',
        title: 'Vista general de salud mental',
        path: '/mentalHealth/dashboard',
        Child: MentalHealtPages.Dashboard,
        payload: {
            header: {
                title: 'Gestión de pacientes salud mental',
                showButtonGoBack: false,
            },
        },
    },
    {
        key: 'health-mental-form-page',
        title: 'Gestión de pacientes salud mental - Crear caso',
        path: '/mentalHealth/form/:id?',
        Child: MentalHealtPages.FormCase,
        payload: {
            header: {
                title: 'Gestión de pacientes salud mental - Crear caso',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'health-mental-detail-page',
        title: 'Gestión de pacientes salud mental - Detalle de caso',
        path: '/mentalHealth/case/:id?',
        Child: MentalHealtPages.DetailCase,
        payload: {
            header: {
                title: 'Gestión de pacientes salud mental - Detalle del paciente',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'user-page',
        title: 'Vista general usuarios del sistema',
        path: '/admin/users',
        Child: AdminPages.Users,
        payload: {
            header: {
                title: 'Administración de usuarios',
                showButtonGoBack: false,
            },
        },
    },
    {
        key: 'user-form-page',
        title: 'Formularios de los usuarios del sistema',
        path: '/admin/users/form/:id',
        Child: AdminPages.FormUsers,
        payload: {
            header: {
                title: 'Administración de usuarios - Editar usuario',
                showButtonGoBack: true,
            },
        },
    },
    {
        key: 'sla-cofnfig-page',
        title: 'Configuración de SLA',
        path: '/admin/settings',
        Child: AdminPages.Settings,
        payload: {
            header: {
                title: 'Configuración administrativa de SLA',
                showButtonGoBack: false,
            },
        },
    },
    {
        key: 'solicitude-form-page',
        title: 'Formulario de solicitud de usuarios',
        path: '/admin/solicitude/form',
        Child: AdminPages.Solicitude,
        payload: {
            header: {
                title: 'Formulario de solicitud de usuarios',
                showButtonGoBack: true,
            },
        },
    },
];
